import { useState } from "react";
import { useApp } from "../store";

// adminOnly: the hub menu at / takes the admin password; the family password only opens the sub-apps.
export default function LoginGate({ adminOnly = false }: { adminOnly?: boolean }) {
  const { login } = useApp();
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(false);
    const r = await login(password);
    const ok = adminOnly ? r.admin : r.authed;
    setBusy(false);
    if (!ok) setError(true);
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <form onSubmit={submit} className="card w-full max-w-sm">
        <h1 className="text-lg font-bold">timtwhit</h1>
        <p className="mt-1 text-sm text-slate-500">{adminOnly ? "Enter the admin password to continue." : "Enter the shared password to continue."}</p>
        <input
          className="input mt-4 w-full"
          type="password"
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
        />
        {error && <p className="mt-2 text-sm text-red-600">That password didn't work.</p>}
        <button className="btn btn-primary mt-4 w-full justify-center" disabled={busy}>
          {busy ? "Checking…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
